import { ThunkAction } from 'redux-thunk';
import { ValueOf } from 'type-fest';
import requestCustomScheduleHolidayTypes from '~/queries/customerCommunication/requestGetCustomScheduleHolidayTypes';
import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import { isRequestInitial } from '~/utils/requestUtils';

import CustomerCommunicationAction, { CustomerCommunicationActionTypes } from './customerCommunicationAction';

type CustomScheduleHolidayTypesParams = NonNullable<
  ValueOf<CustomerCommunication.CustomerCommunicationReduxState['customScheduleHolidayTypesRecords']>['params']
>;

const fetchCustomScheduleHolidayTypes =
  (brandId: string): ThunkAction<void, App.State, unknown, CustomerCommunicationAction> =>
  async (dispatch, getState) => {
    const appState = getState();

    const params = [brandId] as CustomScheduleHolidayTypesParams;
    const key = getRecordKeyFor(...params);
    const existing = appState.customerCommunication.customScheduleHolidayTypesRecords[key];

    if (!existing || isRequestInitial(existing)) {
      dispatch({
        type: CustomerCommunicationActionTypes.SET_CUSTOM_SCHEDULE_HOLIDAY_TYPES_FETCHING,
        params,
      });
      try {
        const destinations = await requestCustomScheduleHolidayTypes(...params);
        dispatch({
          type: CustomerCommunicationActionTypes.SET_CUSTOM_SCHEDULE_HOLIDAY_TYPES_FULFILLED,
          params,
          destinations,
        });
      } catch (error) {
        dispatch({
          type: CustomerCommunicationActionTypes.SET_CUSTOM_SCHEDULE_HOLIDAY_TYPES_REJECTED,
          params,
          error,
        });
      }
    }
  };

export default fetchCustomScheduleHolidayTypes;
